import { jsxs as p, jsx as n, Fragment as $ } from "react/jsx-runtime";
import { useMemo as M, useId as I } from "react";
import { c as x } from "../clsx-OuTLNxxd.js";
import { L as w } from "../Label-Bj2Sx48J.js";
import '../PerformanceIndicator.css';const v = "320px", O = "600px", k = "1025px", A = "_performanceIndicator_1711e_32", L = "_container_1711e_36", j = "_percentage_1711e_48", F = "_label_1711e_56", P = "_indicatorWrapper_1711e_63", R = "_hasMaxWidth_1711e_71", C = "_indicator_1711e_63", D = "_success_1711e_82", E = "_failure_1711e_86", G = "_neutral_1711e_90", U = "_dateTop_1711e_94", Y = "_dateBottom_1711e_95", q = "_teamName_1711e_111", t = {
  mobile: v,
  "mobile-wide": "480px",
  tablet: O,
  "tablet-wide": "800px",
  desktop: k,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  performanceIndicator: A,
  container: L,
  "spacing-s": "_spacing-s_1711e_42",
  "spacing-m": "_spacing-m_1711e_45",
  percentage: j,
  label: F,
  indicatorWrapper: P,
  hasMaxWidth: R,
  indicator: C,
  success: D,
  failure: E,
  neutral: G,
  dateTop: U,
  dateBottom: Y,
  teamName: q
}, b = (a) => {
  switch (a) {
    case "WON":
      return t.success;
    case "LOST":
      return t.failure;
    default:
      return t.neutral;
  }
}, H = ({ children: a, className: d, count: c, label: i, position: m, spacing: s }) => {
  const r = I();
  return /* @__PURE__ */ p("div", { className: x(t.performanceIndicator, d), children: [
    i && /* @__PURE__ */ n(w, { className: t.label, htmlFor: r, children: i }),
    /* @__PURE__ */ n(
      "div",
      {
        "aria-label": "Performance Indicator",
        className: x(t.container, t[`spacing-${s}`]),
        id: r,
        role: "group",
        style: {
          "--indicator-count": c,
          justifyContent: m === "start" ? "flex-end" : "flex-start"
        },
        children: a
      }
    )
  ] });
}, X = ({
  americanFormat: a = !1,
  awayText: d = "A",
  className: c,
  formatDate: i,
  hasMaxWidth: m = !0,
  history: s,
  hitRate: r,
  homeText: h = "H",
  label: S,
  limit: y,
  position: N = "end",
  showHitRate: z = !0,
  showMatchInformation: u = !1,
  spacing: T = "m"
}) => {
  const B = M(
    () => [...s].sort((e, o) => new Date(o.startTime).getTime() - new Date(e.startTime).getTime()).slice(0, y),
    [s, y]
  ), _ = (e) => {
    const o = new Date(e), g = o.getMonth() + 1, l = o.getDate();
    return a ? `${g}/${l}` : `${l}/${g}`;
  }, W = (e, { showFullName: o } = {}) => {
    const g = e.participant.side === "AWAY", l = g ? e.homeTeam : e.awayTeam, f = o ? l.name : l.shortName;
    return a ? g ? `@${f}` : f || l.name : e.participant.side === "HOME" ? `${f} (${h})` : `${f} (${d})`;
  };
  return s.length ? /* @__PURE__ */ p(H, { className: c, count: s.length, label: S, position: N, spacing: T, children: [
    z && /* @__PURE__ */ p("span", { className: t.percentage, "data-testid": "hit-rate", children: [
      r,
      "%"
    ] }),
    B.map((e, o) => /* @__PURE__ */ p(
      "div",
      {
        className: x(t.indicatorWrapper, {
          [t.hasMaxWidth]: m
        }),
        "data-testid": "indicator",
        children: [
          u && /* @__PURE__ */ n("span", { className: t.dateTop, "data-testid": "date-top", children: i ? i(e.startTime, "M/d") : _(e.startTime) }),
          /* @__PURE__ */ n(
            "div",
            {
              "aria-label": `${e.participant.betResult === "WON" ? "Success" : e.participant.betResult === "LOST" ? "Failure" : "Undetermined"} against ${W(e)}`,
              className: x(t.indicator, b(e.participant.betResult)),
              role: "img"
            }
          ),
          u && /* @__PURE__ */ p($, { children: [
            /* @__PURE__ */ n("span", { className: t.teamName, children: W(e) }),
            /* @__PURE__ */ n("span", { className: t.dateBottom, "data-testid": "date-bottom", children: i ? i(e.startTime, "M/d") : _(e.startTime) })
          ] })
        ]
      },
      o
    ))
  ] }) : null;
}, Z = ({
  className: a,
  hasMaxWidth: d,
  history: c,
  label: i,
  position: m,
  spacing: s
}) => c.length ? /* @__PURE__ */ n(H, { className: a, count: c.length, label: i, position: m, spacing: s, children: c.map((r, h) => /* @__PURE__ */ n(
  "div",
  {
    className: x(t.indicatorWrapper, {
      [t.hasMaxWidth]: d
    }),
    "data-testid": "indicator",
    children: /* @__PURE__ */ n("div", { className: x(t.indicator, b(r)), role: "img" })
  },
  h
)) }) : null;
export {
  X as PerformanceIndicator,
  Z as TipsterPerformanceIndicator
};
